// app/javascript/controllers/index.js

// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { Application  } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import BaseShippingController from "./base_shipping_controller"
export { BaseShippingController };

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
import SubscriptionController from "./subscription_controller"
import CancelAccountController from "./cancel_account_controller"
import DateInputController from "./date_input_controller"
application.load(definitionsFromContext(context))
application.register("date-input", DateInputController)

if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test" || process.env.NODE_ENV === "staging") {
  application.debug = true
}
